import { render, staticRenderFns } from "./VendorReviews.vue?vue&type=template&id=c9a2ee42"
import script from "./VendorReviews.vue?vue&type=script&lang=js"
export * from "./VendorReviews.vue?vue&type=script&lang=js"
import style0 from "./VendorReviews.vue?vue&type=style&index=0&id=c9a2ee42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports